import { Data, Params } from '@angular/router';
import { EditorTab } from '@shared/models/editor.model';
import { RouterStateParams } from '@shared/serializers/custom-router-state.serializer';
import { RouterStateModel } from '@ngxs/router-plugin';

/**
 * RouterState is managed by @ngxs/router-plugin
 *
 * Reusable selectors are exported from namespace.
 * Usage:
 *
 *    readonly url = select(RouterState.url);
 */

/* eslint-disable @typescript-eslint/no-namespace */
export namespace RouterState {
  export function url({ router }: { router: RouterStateModel<RouterStateParams> }): string {
    return router?.state?.url || '';
  }

  export function fragment({ router }: { router: RouterStateModel<RouterStateParams> }): string {
    return router?.state?.fragment || '';
  }

  export function routeParams({ router }: { router: RouterStateModel<RouterStateParams> }): Params {
    return router?.state?.params || {};
  }

  export function routeParam<T extends string = string>(param: string) {
    return (state: { router: RouterStateModel<RouterStateParams> }): T | undefined => routeParams(state)[param];
  }

  export function data({ router }: { router: RouterStateModel<RouterStateParams> }): Data {
    return router?.state?.data || {};
  }

  export function dataParam<T = any>(param: string) {
    return (state: { router: RouterStateModel<RouterStateParams> }): T | undefined => data(state)[param] as T;
  }

  export function queryParams({ router }: { router: RouterStateModel<RouterStateParams> }): Params {
    return router?.state?.queryParams || {};
  }

  export function isHomeRoute(state: { router: RouterStateModel<RouterStateParams> }): boolean {
    return url(state) === '/home';
  }

  export function isCartRoute(state: { router: RouterStateModel<RouterStateParams> }): boolean {
    return url(state).startsWith('/plans/cart');
  }

  export function editorTab(state: { router: RouterStateModel<RouterStateParams> }): EditorTab | undefined {
    const path = url(state);
    if (path.includes('surveys/')) {
      if (path.includes(`/${EditorTab.Edit}`)) {
        return EditorTab.Edit;
      }

      if (path.includes(`/${EditorTab.Design}`)) {
        return EditorTab.Design;
      }

      if (path.includes(`/${EditorTab.Setup}`)) {
        return EditorTab.Setup;
      }
    }
  }
}
